import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles, Grid } from '@material-ui/core';
import { formattingDigitCurrency, formattingDateString } from 'utils';
import { useAtom } from 'jotai';
import { staticDataAtom } from 'Atoms/Common';
import { NextIcon } from 'images/svg';

const useStyles = makeStyles((theme) => ({
  listItem: {
    background: 'white',
    height: '55px',
    margin: '5px 0',
    padding: '1rem',
  },
  quantity: {},
  label: {
    margin: '0 .5rem',
    verticalAlign: 'top',
  },
  price: {
    '& p': {
      verticalAlign: 'top',
      fontWeight: 700,
    },
    '& svg': {
      margin: '0 1rem',
    },
  },
  checkbox: {
    color: theme.palette.primary.main,
    borderRadius: '5px',
  },
}));

/**
 *
 * @param {action} object with params "name": readOnly || selected
 */
const DetailTicketLine = ({ date, total }) => {
  const classes = useStyles();
  const [staticData] = useAtom(staticDataAtom);
  const { countryCode, labelCode } = staticData?.currency;
  const amountFormatting = formattingDigitCurrency(
    total,
    countryCode,
    labelCode,
  );

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography display="inline" className={classes.label}>
          {formattingDateString(date, countryCode)}
        </Typography>
      </Grid>
      <Grid item className={classes.price}>
        <Typography display="inline">{amountFormatting}</Typography>
        <NextIcon />
      </Grid>
    </Grid>
  );
};

DetailTicketLine.propTypes = {};

export default DetailTicketLine;
